import React from 'react';
import { useNavigate } from 'react-router-dom';

const LogoButton = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate('/');
    window.location.reload();
  };

  return (
    <button
      className="logo-button"
      onClick={handleClick}
      style={{ background: 'none', border: 'none' }}
    >
      <img
        src="/img/logo.png"
        alt="Logo de la empresa"
        style={{ width: '50px', marginLeft: '20px' }}
      />
    </button>
  );
};

export default LogoButton;
